import { AUTH_LOGOUT_STORAGE_KEY } from '../_CONST';

const notifyAuthLogout = () => {
  try {
    localStorage.setItem(AUTH_LOGOUT_STORAGE_KEY, String(Date.now()));
  } catch (err) {
    // Storage unavailable: cross-tab logout sync is best-effort, never block the logout flow
    console.warn('Cross-tab logout notification failed', err);
  }
};

export { notifyAuthLogout };